import type { FetchArgs } from '@reduxjs/toolkit/query';

export type DailyMetricsParams = {
  from?: string;
  to?: string;
  origin_node_id?: string | number;
  org_id?: string | number;
  owner_id?: string | number;
};

export type DailyMetricsEnvelope = {
  metrics: DailyMetrics;
  status: number;
};

export type DailyMetric = {
  time: string;
  records: number;
  size: number;
  errors: number;
};

export type DailyMetrics = DailyMetric[];

const DAILY_METRICS_PATH = '/data_flows/metrics/daily';

export function getDailyMetricsQueryDefinition(params: DailyMetricsParams): string | FetchArgs {
  return { url: DAILY_METRICS_PATH, params };
}

export type FlowDailyMetricsParams = {
  from?: string;
  to?: string;
};

export type FlowDailyMetricsArg = {
  originNodeId: number | string;
} & FlowDailyMetricsParams;

export function getFlowDailyMetricsQueryDefinition({
  originNodeId,
  ...params
}: FlowDailyMetricsArg): string | FetchArgs {
  return { url: `/flows/${originNodeId}/metrics/daily`, params };
}

export { parseDailyMetricsResponse } from './metrics.utils';
